<template>
<div class="chapter">
<div class="inner_page">
<h3 class="t3b">CONTENTS</h3>
<p class="t2">
<a href="#/Text/Section0004">CHAPTER I</a>
</p>
<p class="t2">
JANUARY TO JULY 1916
</p>
<p class="contents">
General situation—The fight for the Bluff—The Mound of
St. Eloi—Fine performance of Third Division and Canadians—Feat of the
1st Shropshires—Attack on the Irish Division—Fight at Vimy
Ridge—Canadian Battle of Ypres—Death of General
Mercer—Recovery of lost position—Attack of Thirty-ninth
Division—Eve of the Somme
</p>
<p class="t2">
<a href="#/Text/Section0005">CHAPTER II</a>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
  Attack of the Seventh and Eighth Corps on Gommecourt,<br class="calibre8"/>
  Serre, and Beaumont Hamel<br class="calibre8"/>
</p>
<p class="contents">
Line of battle in the Somme sector—Great preparations—Advance of
Forty-sixth North Midland Division—Advance of Fifty-sixth
Territorials (London)—Great valour and heavy losses—Advance
of Thirty-first Division—Advance of Fourth Division—Advance
of Twenty-ninth Division—Complete failure of the assault
</p>
<p class="t2">
<span href="#/Text/Section0006" title="Link target outside of Sample">CHAPTER III</span>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
Attack of the Tenth and Third Corps, July 1, 1916
</p>
<p class="contents">
Magnificent conduct of the Ulster Division—Local success but general
failure—Advance of Thirty-second Division—Advance of Eighth
Division—Advance of Thirty-fourth Division—The turning-point
of the line
</p>
<p class="calibre7">
<a id="Pviii" title="{viii}"></a>
</p>
<p class="t2">
<span href="#/Text/Section0007" title="Link target outside of Sample">CHAPTER IV</span>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
The Attack of the Fifteenth and Thirteenth Corps, July 1, 1916
</p>
<p class="contents">
The advance of the Twenty-first Division—Of the 64th
Brigade—First permanent gains—50th Brigade at Fricourt—Advance of
Seventh Division—Capture of Mametz—Fine work by Eighteenth
Division—Capture of Montauban by the Thirtieth
Division—General view of the battle—Its decisive importance
</p>
<p class="t2">
<span href="#/Text/Section0008" title="Link target outside of Sample">CHAPTER V</span>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
From July 2 to July 14, 1916
</p>
<p class="contents">
General situation—Capture of La Boiselle by Nineteenth
Division—Splendid attack by 36th Brigade upon Ovillers—Siege and
reduction of Ovillers—Operations at Contalmaison—Desperate
fighting at the Quadrangle by Seventeenth Division—Capture of
Mametz Wood by Thirty-eighth Welsh Division—Capture of
Trones Wood by Eighteenth Division
</p>
<p class="t2">
<span href="#/Text/Section0009" title="Link target outside of Sample">CHAPTER VI</span>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
The Breaking of the Second Line. July 14, 1916
</p>
<p class="contents">
The great night advance—The Leicester Brigade at
Bazentin—Assault by Seventh Division—Success of the Third
Division—Desperate fight of Ninth Division at
Longueval—Operations of
First Division on flank—Cavalry advance
</p>
<p class="t2">
<span href="#/Text/Section0010" title="Link target outside of Sample">CHAPTER VII</span>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
July 14 to July 31
</p>
<p class="contents">
Gradual advance of First Division—Hard fighting of Thirty-third
Division at High Wood—The South Africans in Delville
Wood—The great German counter-attack—Splendid work of 26th
Brigade—Capture of Delville Wood by 98th Brigade—Indecisive
fighting on the Guillemont front
</p>
<p class="calibre7">
<a id="Pix" title="{ix}"></a>
</p>
<p class="t2">
<span href="#/Text/Section0011" title="Link target outside of Sample">CHAPTER VIII</span>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
  The Operations of Gough's Army upon the Northern Flank<br class="calibre8"/>
  up to September 15<br class="calibre8"/>
</p>
<p class="contents">
Advance, Australia!—Capture of Pozières—Fine work of Forty-eighth
Division—Relief of Australia by Canada—Steady advance of
Gough's Army—Capture of Courcelette
</p>
<p class="t2">
<span href="#/Text/Section0012" title="Link target outside of Sample">CHAPTER IX</span>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
August 1 to September 15
</p>
<p class="contents">
Continued attempts of Thirty-third Division on High
Wood—Co-operation of First Division—Operation of Fourteenth Division
on fringe of Delville Wood—Attack by Twenty-fourth Division
on Guillemont—Capture of Guillemont by 47th and 59th
Brigades—Capture of Ginchy by Sixteenth Irish Division
</p>
<p class="t2">
<span href="#/Text/Section0013" title="Link target outside of Sample">CHAPTER X</span>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
Breaking of the Third Line, September 15
</p>
<p class="contents">
Capture of Martinpuich by Fifteenth Division—Advance of Fiftieth
Division—Capture of High Wood by Forty-seventh Division—Splendid
advance of New Zealanders—Capture of Flers by
Forty-first Division—Advance of the Light Division—Arduous
work of the Guards and Sixth Divisions—Capture of
Quadrilateral—Work of Fifty-sixth Division
on flank—Debut of the tanks
</p>
<p class="t2">
<span href="#/Text/Section0014" title="Link target outside of Sample">CHAPTER XI</span>
</p>
<p class="t2">
THE GAINING OF THE THIEPVAL RIDGE
</p>
<p class="contents">
Assault on Thiepval by Eighteenth Division—Heavy
fighting—Co-operation of Eleventh Division—Fall
of Thiepval—Fall of
Schwaben Redoubt—Taking of Stuff Redoubt—Important gains
on the Ridge
</p>
<p class="calibre7">
<a id="Px" title="{x}"></a>
</p>
<p class="t2">
<span href="#/Text/Section0015" title="Link target outside of Sample">CHAPTER XII</span>
</p>
<p class="t2">
THE BATTLE OF THE SOMME
</p>
<p class="t2">
From September 15 to the Battle of the Ancre
</p>
<p class="contents">
Capture of Eaucourt—Varying character of German resistance—Hard
trench fighting along the line—Dreadful climatic
conditions—The meteorological trenches—Hazy Trench—Zenith
Trench—General observations—General von Arnim's report
</p>
<p class="t2">
<span href="#/Text/Section0016" title="Link target outside of Sample">CHAPTER XIII</span>
</p>
<p class="t2">
THE BATTLE OF THE ANCRE
</p>
<p class="t2">
November 13, 1916
</p>
<p class="contents">
The last effort—Failure in the north—Fine work of the Thirty-ninth,
Fifty-first, and Sixty-third Divisions—Surrounding of German
Fort—Capture of Beaumont Hamel—Commander Freyberg—Last
operations of the season—General survey—"The unwarlike
Islanders"</p>
<p class="calibre7">
<a id="Pxi" title="{xi}"></a>
</p>
<p class="t3b">
MAPS AND PLANS
</p>
<p class="contents">
<a href="#/Text/Section0003#img-xii">Approximate Positions of British Line at the Battle of the Somme</a>
</p>
<p class="contents">
<a href="#/Text/Section0005#img-035">British Battle Line, July 1, 1916</a>
</p>
<p class="contents">
<span href="#/Text/Section0008#img-119" title="Link target outside of Sample">Quadrangle Position, July 5-11, 1916</span>
</p>
<p class="contents">
<span href="#/Text/Section0008#img-127" title="Link target outside of Sample">Mametz Wood</span>
</p>
<p class="contents">
<span href="#/Text/Section0008#img-141" title="Link target outside of Sample">Trones Wood: Attack of 54th Brigade, July 13, 1916</span>
</p>
<p class="contents">
<span href="#/Text/Section0009#img-144" title="Link target outside of Sample">The Second German Line, Bazentins, Delville Wood, etc.</span>
</p>
<p class="contents">
<span href="#/Text/Section0010#img-181" title="Link target outside of Sample">Map of Delville Wood</span>
</p>
<p class="contents">
<span href="#/Text/Section0012#img-225" title="Link target outside of Sample">Attack on German Left Flank, September 3, 1916</span>
</p>
<p class="contents">
<span href="#/Text/Section0013#img-239" title="Link target outside of Sample">Final Position at Capture of Martinpuich</span>
</p>
<p class="contents">
<span href="#/Text/Section0013#img-257" title="Link target outside of Sample">Attack on Quadrilateral, September 15, 1916</span>
</p>
<p class="contents">
<span href="#/Text/Section0014#img-265" title="Link target outside of Sample">Plan illustrating the Capture of Thiepval, September 26,
October 5, 1916</span>
</p>
<p class="contents">
<span href="#/Text/Section0014#img-277" title="Link target outside of Sample">Stuff Redoubt System, showing Hessian, Regina, and Stuff</span>
</p>
<p class="contents">
<span href="#/Text/Section0015#img-296" title="Link target outside of Sample">Meteorological Trenches, September 30-November 6, 1916</span></p>
<p class="capcenter">
<a id="img-xii"></a>
<img alt="APPROXIMATE POSITIONS OF BRITISH LINE AT THE BATTLE OF THE SOMME" class="imgcenter" id="id-6539397425267078531" src="Images/img0013.jpg"/>
<br class="calibre8"/>
APPROXIMATE POSITIONS OF BRITISH <br class="calibre8"/>
LINE AT THE BATTLE OF THE SOMME
</p>
<p class="calibre7"><a id="chap01"></a></p>
<p class="calibre7"><a id="P1" title="{1}"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?63133208